import React from "react";
import { AddressInputs } from "Components/AddressInputs";
import { AsteriskNotification } from "Components/AsteriskNotification";
import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { HeadingTitle } from "Components/HeadingTitle";
import { useDocumentTitle } from "Components/Hooks";
import { Horizontal } from "Components/Horizontal";
import { PhoneInput } from "Inputs/PhoneInput";
import { EmailInput, Textbox } from "Inputs/Textbox";
import { EnterAgentInformationModel } from "SharedConstants/Schema";
import { MVCForm, MVCFormServerProps } from "../MVCForm";

export function EnterAgentInformation(
  props: EnterAgentInformationModel & {
    formProps: MVCFormServerProps;
  },
) {
  useDocumentTitle(`Agency Information - ${props.ProducerAgencyName}`);
  return (
    <>
      <HeadingTitle>Agency Information</HeadingTitle>
      <MVCForm {...props.formProps}>
        {({ isSubmitting }) => (
          <>
            <AsteriskNotification />
            <Horizontal isRequired label="Name">
              <Textbox fieldName="AgencyName" placeholder="Agency Name" />
            </Horizontal>
            <Horizontal isRequired label="Phone">
              <PhoneInput fieldName="AgencyPhoneNumber" />
            </Horizontal>
            <Horizontal isRequired label="Fax">
              <PhoneInput fieldName="AgencyFaxNumber" />
            </Horizontal>
            <AddressInputs isRequired label="Agency Address" />
            <Horizontal isRequired label="Representative">
              <Textbox
                fieldName="RepresentativeFirstName"
                placeholder="First Name"
              />
              <Textbox
                fieldName="RepresentativeLastName"
                placeholder="Last Name"
              />
            </Horizontal>
            <Horizontal isRequired label="Email">
              <EmailInput
                fieldName="EmailAddress"
                placeholder="name@agency.com"
              />
            </Horizontal>
            <Horizontal isRequired label="Confirm Email">
              <EmailInput
                fieldName="ConfirmEmailAddress"
                placeholder="name@agency.com"
              />
            </Horizontal>
            <BulmaNavButtons
              backCaption="Back to Highlights"
              continueCaption="Continue"
              isDisabled={isSubmitting}
            />
          </>
        )}
      </MVCForm>
    </>
  );
}
